var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlayIcon = function SvgPlayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.38 12.065C23.38 5.817 18.312.75 12.064.75 5.817.75.75 5.817.75 12.065c0 6.248 5.067 11.314 11.315 11.314 6.248 0 11.314-5.066 11.314-11.314Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17.138 11.15-7.73-4.751a.7.7 0 0 0-1.065.597v9.458c0 .252.137.486.353.61a.701.701 0 0 0 .703-.013l7.73-4.712a.695.695 0 0 0 .336-.592.67.67 0 0 0-.327-.597Z"
  })));
};
export default SvgPlayIcon;